<template>
    <div>
      <div class="projects">
         <h1 style="color:white;font-size:3rem; margin-left:38%; font-style:italic;">My Projects</h1>
            <div class="best" id="prj1" 
       >

           <div class="smash">
               <div class="first-pic">
                   <img src="../assets/smash1.png" alt=""/>
               </div>


               <div class="second-pic">
                   <img src="../assets/smash2.png" alt=""/>
               </div>

               
           </div>

           <div class="buttons">
               <button class="live"> <a href="https://gads-project-1.web.app/"> Live link</a></button>
               <button class="git"> <a href="https://github.com/Adenikym/gads-project">  Github Repo</a></button>
           </div>

          <p class="description">Event App: This project is a simple progressive web application built for events. It has a weather feature which helps determine whether events would take place or not.</p>
           </div> 

                  <div class="best" id="prj1" 
       >

           <div class="smash">
               <div class="first-pic">
                   <img src="../assets/weather.png" alt=""/>
               </div>


               <div class="second-pic">
                   <img src="../assets/weather.png" alt=""/>
               </div>

               
           </div>

           <div class="buttons">
               <button class="live"> <a href="https://frosty-shannon-weather-app.netlify.app/"> Live link</a></button>
               <button class="git"> <a href="https://github.com/Adenikym/weather-app">  Github Repo</a></button>
           </div>

          <p class="description">Weather App: A simple application with which weather conditions in specific locations can be gotten with a simple search.</p>
           </div> 

           <div class="best" id="prj2"
       >

           <div class="smash" >
               <div class="first-pic">
                   <img src="../assets/hub.png" alt=""/>
               </div> 


               <div class="second-pic">
                   <img src="../assets/hub2.png" alt=""/>
               </div>

               
           </div>

           <div class="buttons">
               <button class="live"> <a href="https://foodhub-564ea.web.app/"> Live link</a></button>
               <button class="git">Github Repo</button>
           </div>

           <p class="description">FoodHub: This project is a simple web application for a restaurant built with vue.js.</p>
           </div> 
<div class="best" id="prj4"
       >

           <div class="smash">
               <div class="first-pic">
                   <img src="../assets/Course1.png" alt=""/>
               </div>


               <div class="second-pic">
                   <img src="../assets/course.png" alt=""/>
               </div>

               
           </div>

           <div class="buttons">
               <button class="live"> <a href="https://xcourse-site.netlify.app/">  Live link</a></button>
               <button class="git"> <a href="https://github.com/Adenikym/team19-week-1"> Github Repo</a></button>
           </div>

           <p class="description">XCourse: This is a site for the sale of courses either with referrals or money. Built with--html, css and Javascript</p>
           </div> 
<div class="best" id="prj5"
      >

           <div class="smash">
               <div class="first-pic">
                   <img src="../assets/covid1.png" alt=""/>
               </div>


               <div class="second-pic">
                   <img src="../assets/covid2.png" alt=""/>
               </div>

               
           </div>

           <div class="buttons">
               <button class="live"> <a href="https://ecx-covid-tracker.netlify.app/"> Live link</a></button>
               <button class="git"> <a href="https://github.com/ECX-Unilag/Team-11-Stage-3">  Github Repo</a></button>
           </div>

           <p class="description">Covid Tracker:This is a covid-19 information website which supplies up to date statistics. I created if in collaboration with other frontend developers during the ECX internship. Built with- html, CSS, Javascript and bootstrap</p>
           </div> 
<div class="best" id="prj6"
       >

           <div class="smash">
               <div class="first-pic">
                   <img src="../assets/admit1.png" alt=""/>
               </div>


               <div class="second-pic">
                   <img src="../assets/admit2.png" alt=""/>
               </div>

               
           </div>

           <div class="buttons">
               <button class="live"> <a href="http://ecx-admission-portal.herokuapp.com/"> Live link</a></button>
               <button class="git"> <a href="https://github.com/ECX-Unilag/Team-11-Week-2">  Github Repo</a></button>
           </div>

           <p class="description">Admission Portal: This is an admission portal user interface for Students. It was collaboratively built with some other frontend developers.</p>
           </div> 
<div class="best" id="prj7"
       >

           <div class="smash">
               <div class="first-pic">
                   <img src="../assets/mimeal1.png" alt=""/>
               </div>


               <div class="second-pic">
                   <img src="../assets/mimeal2.png" alt=""/>
               </div>

               
           </div>

           <div class="buttons">
               <button class="live"> <a href="https://mimeal.herokuapp.com/">  Live link</a></button>
               <button class="git"> <a href="https://github.com/DSC-Unilag/ohw-2020-20"> Github Repo</a></button>
           </div>

           <p class="description">Food App Project: This is a random meal search platform which i created in collaboration with two other coders.'</p>
           </div> 


           
       </div>  
    </div>
</template>


<script>
export default {
    name:'project',

}
</script>

<style scoped>

*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
    .smash{
    display: flex;
    margin-top: 40px;
    width:80%;
    margin-left: 10%;
   
}
.first-pic, .second-pic{
    border:1px solid white;
    width:24%;
    height: 300px;
     margin-left: 18%;
     overflow-y: scroll;

}

.second-pic{
  margin-left: 12%;
}

.projects{
 
  background-color: black;
}

.buttons{
    display: flex;
    color: white;
    margin-top: 20px;
    width:60%;
    margin-left: 18%;
   margin-bottom: 25px;
}

.buttons button{
    padding:5px 10px;
    width:20%;
    

    border:1px solid #4d4dff;
   
}

.buttons .live{
     margin-left: 16%;
}

.buttons .git{
    margin-left: 29%;
}

.description{
    width:30%;
    margin-left: 8%;
    text-align: center;
    color: #fff;
    margin-left: 35%;
    line-height: 2rem;
}

/*media queries*/

@media only screen and (max-width: 1125px){


    .buttons button{
        width:25%;
    }


    .first-pic, .second-pic{
    
    width:28%;
    height: 300px;
     margin-left: 18%;
     
}

.buttons .git{
    margin-left: 38%;
}
}

@media only screen and (max-width:920px){
     .buttons{
   
    width:70%;
    margin-left: 8%;
   margin-bottom: 25px;
}
     
     
     
     
     .buttons button{
        width:60%;
    }


    .first-pic, .second-pic{
    
    width:33%;
     margin-left: 18%;
     
}

.buttons .git{
    margin-left: 50%;
}

 .smash{
    
    margin-left: 5%;
   
}
}


@media only screen and (max-width:768px){


    .smash{
        width: 100%;
        margin-left:0%;
        margin-right: 0%;
        
       
    }
      .first-pic, .second-pic{
    
    width:55%;

     margin-left: 8%;}

     .projects h1{
        
         margin-left:25% !important ;
     }
}

@media only screen and (max-width: 576px){
    .smash{
        display: block;
    }

    .first-pic{
margin-bottom: 20px;
    }

    .first-pic, .second-pic{
        margin-left: 16%;
        width:63%;
      

    }


    .projects h1{
        
         margin-left:18% !important ;
         margin-top: 10px !important;
         font-size: 2.5rem !important;
     }


     .button .git{
         margin-left: 10%;
     }

      .buttons{
   
    width:70%;
    margin-left: 8%;
   margin-bottom: 25px;
}
     
     
     
     
     .buttons button{
        width:80%;
    }

    .description{
        width: 80%;
        margin-left: 10%;
    }
}



/* animations*/
#prj1{
    animation-name:prj1;
    animation-duration: 2s;
    animation-fill-mode: forwards;
position: relative;
}

@keyframes prj1 {
    0%{
left: -1000px; opacity: 0;
    }

    100%{
        left: 50px; opacity: 1;
    }


    
}

#prj2{
      animation-name:prj2;
    animation-duration: 3s;
    animation-delay: 2s;
    animation-fill-mode: forwards;
position: relative;  
    }

@keyframes prj2 {
    0%{
left: -1000px;opacity: 0;
    }

    100%{
        left: 50px;opacity: 1;
    }}

#prj4{
      animation-name:prj4;
    animation-duration: 3s;
    animation-delay: 4s;
    animation-fill-mode: forwards;
position: relative;  
    }

@keyframes prj4 {
    0%{
left: -1000px;
    }

    100%{
        left: 50px;
    }}

    #prj5{
      animation-name:prj5;
    animation-duration: 3s;
    animation-delay: 6s;
    animation-fill-mode: forwards;
position: relative;  
    }

@keyframes prj5{
    0%{
left: -1000px;
    }

    100%{
        left: 50px;
    }}


    #prj6{
      animation-name:prj6;
    animation-duration: 3s;
    animation-delay: 8s;
    animation-fill-mode: forwards;
position: relative;  
    }

@keyframes prj6{
    0%{
left: -1000px;
    }

    100%{
        left: 50px;
    }}

    #prj7{
      animation-name:prj7;
    animation-duration: 3s;
    animation-delay: 10s;
    animation-fill-mode: forwards;
position: relative;  
    }

@keyframes prj7{
    0%{
left: -1000px;
    }

    100%{
        left: 50px;
    }}

    @media only screen and (max-width:400px ){
        @keyframes prj1{
    0%{
left: -1000px; opacity: 0;
    }

    100%{
        left: 5px; opacity: 1;
    }
    }

     @keyframes prj2{
    0%{
left: -1000px; opacity: 0;
    }

    100%{
        left: 5px; opacity: 1;
    }
    }

     @keyframes prj3{
    0%{
left: -1000px; opacity: 0;
    }

    100%{
        left: 5px; opacity: 1;
    }
    }

     @keyframes prj4{
    0%{
left: -1000px; opacity: 0;
    }

    100%{
        left: 5px; opacity: 1;
    }
    }

     @keyframes prj5{
    0%{
left: -1000px; opacity: 0;
    }

    100%{
        left: 5px; opacity: 1;
    }
    }

     @keyframes prj6{
    0%{
left: -1000px; opacity: 0;
    }

    100%{
        left: 5px; opacity: 1;
    }
    }

     @keyframes prj7{
    0%{
left: -1000px; opacity: 0;
    }

    100%{
        left: 5px; opacity: 1;
    }
    }

.buttons{
   
    width:90%;
    margin-left: 0%;
   margin-bottom: 25px;
  
}

.buttons button{
        width:90%;
    }

      .button .git{
         margin-left: 0%;
     }

     .buttons .live{
     margin-left: 0%;
}

 .description{
        width: 80%;
        margin-left: 7%;
    }

    }
</style>
